<template>
  <div class="card">
    <header class="bandeau-modal card-header"/>
    <div class="card-content pd-40px">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{$t('listeJournalEcriture.actions.libellePopupCreateLot')}}
        </p>
        <error-msg-component :messages="messages"
                             :error="messages.length > 0"
                             :withEmplyFields="true"
                             @close="messages = []"/>
      </section>
      <div class="mgb-40px">
        <b-field
          :label="$t('listeJournalEcriture.actions.labelPopupLot')">
          <b-input v-model="libelleLot" ref="libelleInput"/>
        </b-field>
      </div>
      <div class="buttons">
        <qd-button type="is-light"
                  class="btn-modal-annuler"
                  @click="close()">
          {{$t('listeJournalEcriture.actions.boutonPopupClose')}}
        </qd-button>
        <qd-button type="is-info"
                  @click="save()">
          {{$t('listeJournalEcriture.actions.boutonPopupCreate')}}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import { create } from '@/api/compta/ifLot/index';
import { insertIntoIfLot } from '@/api/compta/ifEcriture/index';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/compta/journal/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    ecritures: Array,
  },
  components: {
    errorMsgComponent,
  },
  data: () => ({
    libelleLot: '',
    messages: [],
  }),
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    label() {
      return '';
    },
  },
  methods: {
    close(val) {
      this.$emit('close', val);
    },
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const responceCreate = await create({
          societeId: this.societeActiveId,
          libelle: this.libelleLot,
        });
        await insertIntoIfLot({
          ifLotId: responceCreate.data.result.id,
          ifEcrituresIds: this.ecritures,
        });
        messageSucces(this.libelleLot + ' ' + this.$t('listeJournalEcriture.actions.msgSuccess'));
        this.$emit('save');
        this.close(true);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messages, this.$i18n);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.libelleLot = this.$t('listeJournalEcriture.libelleLotAjout') + moment().format('L');
    this.$refs.libelleInput.focus();
  },
};
</script>

<style>

</style>
